/**
 * @desc review (REFACTOR)
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** codes */
  codes: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.HttpResponse>(`/storeapi/api/r/review/close/code`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
